import { render, staticRenderFns } from "./StyleManagerColorGroupPicker.vue?vue&type=template&id=2208efdd&scoped=true"
import script from "./StyleManagerColorGroupPicker.vue?vue&type=script&lang=js"
export * from "./StyleManagerColorGroupPicker.vue?vue&type=script&lang=js"
import style0 from "./StyleManagerColorGroupPicker.vue?vue&type=style&index=0&id=2208efdd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2208efdd",
  null
  
)

export default component.exports